import React, { useEffect, useState } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import { BaseSettingIcon, CustomUserIcon, LogoutIcon, ProfileSettingIcon, SwitchBaseIcon, UserRoleIcon, baseNameIcon } from '../icons';
import { useAppDispatch, useAppSelector } from '../../app/hooks';
import { toast } from 'sonner';
import { logoutUser } from '../../features/auth/authSlice';
import { useSidebar } from '../../context/SidebarContext';
import { useSidebarMenuHover } from '../../context/CustomHoverContext';


const JobVerticleSidebar = ({ updateBaseLogo, navigation }: any) => {
  const location = useLocation();
  const [updateProfileImage, setUpdateProfileImage] = useState("")
  const [userData, setUserData] = useState<any>(null);
  const navigate = useNavigate();
  const [userId, setUserId] = useState<any>(null);
  const { baseId, jobId } = useParams<{ baseId: string; jobId: string }>();
  const [userBaseData, setUserBaseData] = useState<any>(null)
  const userDetailsFromRedux = useAppSelector((state: any) => state?.base?.baseDetails);
  const dispatch = useAppDispatch();
  const { verticleSidebar, setVerticleSidebar } = useSidebar();
  const [isHovered, setIsHovered] = useState(false);
  const { setIsTooltipHovered } = useSidebarMenuHover();

  // user details
  useEffect(() => {
    const userDetailsString = localStorage.getItem('userDetails');
    if (userDetailsString) {
      try {
        let userDetails = JSON.parse(userDetailsString);
        setUserData(userDetails)
      } catch (e) {
        console.error("Error parsing userDetails:", e);
      }
    }
  }, []);

  useEffect(() => {
    const storedUserDetails = JSON.parse(localStorage.getItem("userDetails") || "{}");
    setUserId(storedUserDetails);
  }, []);

  // base details

  useEffect(() => {
    const userBaseDetailsString = localStorage.getItem('baseDetails');
    if (userBaseDetailsString) {
      try {
        const userBaseDetails = JSON.parse(userBaseDetailsString); // Declare the variable here
        setUserBaseData(userBaseDetails?.data);
      } catch (e) {
        console.error("Error parsing userDetails:", e);
      }
    }
  }, []);

  const handleBaseNavigate = () => {
    navigate('/base')
  }

  const handleProfileSetting = () => {
    navigate(`/user/${userId?.id}/profile`)
  }

  const handleBaseSetting = () => {
    navigate(`/${baseId}/settings/base/`)
  }

  const handleSignOut = () => {
    const clearAllStorageData = () => {
      // Clear all localStorage
      localStorage.clear();

      // Specifically remove items related to authentication and persistence
      const keysToRemove = [
        "accessToken",
        "authToken",
        "persist:root",
        "_persist"
      ];

      keysToRemove.forEach(key => localStorage.removeItem(key));

      // If you're using cookies for any auth data, clear them here
      // For example:
      // document.cookie.split(";").forEach(c => {
      //   document.cookie = c.replace(/^ +/, "").replace(/=.*/, "=;expires=" + new Date().toUTCString() + ";path=/");
      // });
    };

    dispatch(logoutUser())
      .then((resultAction) => {
        if (logoutUser.fulfilled.match(resultAction)) {
          clearAllStorageData();
          toast.success('Successfully logged out!');

          // Use a slight delay to ensure storage clearing is complete
          setTimeout(() => {
            navigate('/login');
          }, 100);
        } else if (logoutUser.rejected.match(resultAction)) {
          const payload = resultAction.payload as { status?: number; message: string };
          if (payload.status === 401) {
            clearAllStorageData();
            toast.error('Session expired. Please log in again.');

            setTimeout(() => {
              window.location.href = '/login';
            }, 100);
          } else {
            toast.error('Logout failed. Please try again.');
          }
        }
      })
      .catch((error) => {
        console.error('Logout action failed', error);
        toast.error('Logout action failed. Please try again.');
      });
  };




  // custom dropdown 
  const profileMenuSections = [
    {
      options: [
        { icon: CustomUserIcon, label: userData?.name, onClick: () => console.log('Profile clicked') },
        { icon: ProfileSettingIcon, label: 'Profile Setting', onClick: handleProfileSetting },
      ],
    },
    {
      options: [
        { icon: baseNameIcon, label: userBaseData?.base?.name || userDetailsFromRedux?.name, onClick: () => console.log('Profile clicked') },
        { icon: UserRoleIcon, label: userData?.role || userBaseData?.base?.role, onClick: () => console.log('Profile clicked') },
        // { icon: CogIcon, label: 'Base Setting', onClick: handleBaseSetting },
        ...(userData?.role === 'admin'
          ? [{ icon: BaseSettingIcon, label: 'Base Setting', onClick: handleBaseSetting }]
          : []),
      ],
    },
    {
      options: [
        { icon: SwitchBaseIcon, label: 'Create/Switch Base', onClick: handleBaseNavigate }
      ],
    },
    {
      options: [
        { icon: LogoutIcon, label: 'Sign out', onClick: handleSignOut }
      ],
    },
  ];

  // fetch base logo
  useEffect(() => {
    const storedData = localStorage.getItem("userDetails");
    if (storedData) {
      try {
        const parsedData = JSON.parse(storedData);
        if (parsedData && parsedData.profile_pic) {
          setUpdateProfileImage(parsedData && parsedData.profile_pic);
        }
      } catch (error) {
        console.error("Error parsing stored channel data:", error);
      }
    }
  }, [updateBaseLogo])

  // fetch user image 
  const imageUrl = updateProfileImage
    ? `${process.env.REACT_APP_API_BASE_URL}/${updateProfileImage}`
    : 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80';


  const handleSidebarClose = () => {
    setVerticleSidebar(!verticleSidebar)

  }



  return (
    <div
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      className="fixed left-[8px] top-[52px] h-[calc(100vh_-62px)] pb-[8px] w-[50px] bg-white flex flex-col mt-[2px] rounded-tl-lg rounded-bl-lg ring-1 lg:ring-zinc-950/5 shadow-xs">
      {/* Logo at the top */}
      {/* <div className="p-2 flex justify-center">
        {updateBaseLogo ? (
          <img
            src={`${process.env.REACT_APP_API_BASE_URL}/${updateBaseLogo}`}
            alt="Base logo"
            className="h-8 w-8 rounded-md"
          />
        ) : (
          <img
            src="https://www.gravatar.com/avatar/2c7d99fe281ecd3bcd65ab915bac6dd5?s=250"
            alt="Default logo"
            className="h-8 w-8 rounded-md"
          />
        )}
      </div> */}

      {/* Navigation Icons */}
      <nav className="flex-1 flex flex-col items-center gap-2 py-2 px-0"

      >
        {navigation.map((item: any) => {
          const isActive = location.pathname === item.to;
          return (
            <Link
              key={item.name}
              to={item.to}
              data-title={item.name}
              className={`table-tooltip1 relative px-2 py-2 rounded-md transition-colors ${isActive ? 'bg-gray-100' : 'hover:bg-[#f4f4f5]'
                }`}
              onMouseEnter={() => setIsTooltipHovered(true)}
              onMouseLeave={() => setIsTooltipHovered(false)}
            // onMouseEnter={() => setHoveredItem(item.name)}
            // onMouseLeave={() => setHoveredItem(null)}
            >
              <item.icon
                className={`w-5 h-5 ${isActive ? 'text-black' : 'text-gray-500'
                  }`}
              />

              {/* Tooltip */}
              {/* {hoveredItem === item.name && (
                <div className="table-tooltip-list before:!bottom-[18px] before:!left-[11px]">
                  {item.name}
                </div>
              )} */}
            </Link>
          );
        })}
      </nav>

      {/* <nav className="flex-1 flex flex-col items-center gap-2 py-2 px-0 mt-5">
        <Link
          to={`/${baseId}/job/${jobId}/jobs`}
          data-title="Job openings"
          onMouseEnter={() => setIsTooltipHovered(true)}
          onMouseLeave={() => setIsTooltipHovered(false)}
          className={`table-tooltip1 relative px-2 py-2 rounded-md transition-colors bg-white hover:bg-[#f4f4f5]`}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={24}
            height={24}
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth={2}
            strokeLinecap="round"
            strokeLinejoin="round"
            className="icon icon-tabler icons-tabler-outline icon-tabler-device-gamepad-3 w-[1rem] h-[1rem] text-[#808080]"
          >
            <path stroke="none" d="M0 0h24v24H0z" fill="none" />
            <path d="M9 12l-3 -3h-2a1 1 0 0 0 -1 1v4a1 1 0 0 0 1 1h2z" />
            <path d="M15 12l3 -3h2a1 1 0 0 1 1 1v4a1 1 0 0 1 -1 1h-2z" />
            <path d="M12 15l-3 3v2a1 1 0 0 0 1 1h4a1 1 0 0 0 1 -1v-2z" />
            <path d="M12 9l-3 -3v-2a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v2z" />
          </svg>
        </Link>
        <div className=''></div>

      </nav> */}
      {/* dont remove this line */}
      <nav className="flex-1 flex flex-col items-center gap-2 py-2 px-0 justify-end">
        {/* <Link
          onMouseEnter={() => setIsTooltipHovered(true)}
          onMouseLeave={() => setIsTooltipHovered(false)}
          to={`/${baseId}/job/${jobId}/manage/detail`}
          data-title="Setting"
          className={`table-tooltip1 relative px-2 py-2 rounded-md transition-colors bg-white hover:bg-[#f4f4f5]`}
        >
          <SettingIcon />
        </Link> */}
        {/* <Link
          onMouseEnter={() => setIsTooltipHovered(true)}
          onMouseLeave={() => setIsTooltipHovered(false)}
          to=""
          data-title="Share feedback"
          className={`table-tooltip1 relative px-2 py-2 rounded-md transition-colors bg-white hover:bg-[#f4f4f5]`}
        >
          <FlagIcon />
        </Link> */}
      </nav>

      <div className='h-[34px]'>
        {/* {isHovered && ( */}
        <button
          className='flex flex-col items-center gap-2 py-2 px-2 mx-2 rounded-md justify-end bg-white hover:bg-[#f4f4f5]'
          onClick={handleSidebarClose}
        >

          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={24}
            height={24}
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth={2}
            strokeLinecap="round"
            strokeLinejoin="round"
            className="icon icon-tabler icons-tabler-outline icon-tabler-layout-sidebar-right-collapse w-[1rem] h-[1rem] text-[#808080]"
          >
            <path stroke="none" d="M0 0h24v24H0z" fill="none" />
            <path d="M4 4m0 2a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2z" />
            <path d="M15 4v16" />
            <path d="M9 10l2 2l-2 2" />
          </svg>

        </button>
        {/* // )} */}
      </div>

      {/* Menu Dropdown at bottom */}
      {/* <div className="p-2 flex justify-center">
        <CustomMenuDropdownVertical
          imageUrl={imageUrl}
          altText="User profile"
          sections={profileMenuSections}
        />
      </div> */}
    </div>
  );
};

export default JobVerticleSidebar;